import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSaidaProduto } from '../../../slices/saidaProductSlice.js';
import { useSearchParams } from 'react-router-dom';
import Main from '../../../components/Main/Main.jsx';
import Title from '../../../components/Title.jsx';
import TableHistoricSaida from '../../../components/Table/TableHistoricSaida.jsx';
import InputSearch from '../../../components/Search/InputSearch.jsx';
import usePageTitle from '../../../hook/usePageTitle.js';
import {
  Button,
  IconButton,
  Input,
  Option,
  Select,
  Tooltip,
  Typography,
} from '@material-tailwind/react';
import { useForm } from 'react-hook-form';
import { formatarDataBr } from '../../../ultis/validate.js';
import { useExportExcel } from '../../../hook/useExportExcel.js';
import { Download, Combine, Merge } from 'lucide-react';
import { LOCAIS_SAIDA } from '../../../components/autoComplet/LinhasDeSaida.jsx';
import { useGroupDataByID } from '../../../hook/useAgroupDataByID.js';
import TableHistoricSaidaAgroup from '../../../components/Table/TableHisotircSaidaAgroup.jsx';

const columns = [
  { id: 'data', label: 'Data', width: 50 },
  { id: 'produtoNome', label: 'Produto', width: 300 },
  { id: 'quantidade', label: 'Quantidade', width: 130 },
  { id: 'funcionario', label: ' Solicitante', width: 130 },
  { id: 'linha', label: 'Linha', width: 130 },
  { id: 'equipamento', label: 'Equipamento', width: 130 },
];

const columnsAgroup = [
  { id: 'data', label: 'PRIMEIRA - Ultima', width: 50 },
  { id: 'produtoNome', label: 'Produto', width: 300 },
  { id: 'quantidade', label: 'Total', width: 130 },
  { id: 'estoque', label: 'Estoque', width: 230 },
];

const HistoricoSaida = () => {
  usePageTitle();

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get('historico');
  const { saidas, loading } = useSelector((state) => state.saidaProduct);
  const [inputSearch, setInputSeacrh] = useState('');

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  const [filtroDate, setFiltroDate] = useState(null);
  const [filtroLinha, setFiltroLinha] = useState('');
  const [agroupData, setAgroupData] = useState(false);

  const changeAgroupData = () => {
    setAgroupData(!agroupData);
  };

  const clearError = () => {
    reset({ dateFinal: null, dateInicial: null });
    setFiltroDate(null);
    setFiltroLinha('');
    limparParametroHistorico(searchParams, setSearchParams);
  };

  const onFiltro = (date) => {
    const dateInicial = formatarDataBr(date.dateInicial);
    const dateFinal = formatarDataBr(date.dateFinal);
    setFiltroDate({ dateFinal, dateInicial });
  };

  useEffect(() => {
    setInputSeacrh(search);
  }, [search]);

  const dadosFiltrados = saidas.filter((produto) => {
    const search = inputSearch?.toLowerCase() || '';

    const produtoNomeMatch = produto.produtoNome.toLowerCase().includes(search);
    const equipamentoMatch = produto.equipamento.toLowerCase().includes(search);
    const produtoMatch = produto.produto.toString().toLowerCase() === search;
    const filtroLinhaMatch = filtroLinha
      ? produto.linha.toLowerCase() === filtroLinha.toLowerCase()
      : true;

    // Verifica se temos um filtro de data válido
    let dentroDoPeriodo = true;

    if (filtroDate?.dateInicial && filtroDate?.dateFinal) {
      const dateProduct = produto?.data.split('/');
      const dateProductDate = new Date(dateProduct[2], dateProduct[1] - 1, dateProduct[0]);

      const dateIn = filtroDate.dateInicial.split('/');
      const dateEnd = filtroDate.dateFinal.split('/');

      const dateinDate = new Date(dateIn[2], dateIn[1] - 1, dateIn[0]);
      const dateEndDate = new Date(dateEnd[2], dateEnd[1] - 1, dateEnd[0]);

      dentroDoPeriodo = dateProductDate >= dateinDate && dateProductDate <= dateEndDate;
    }

    return (
      (produtoNomeMatch || equipamentoMatch || produtoMatch) && filtroLinhaMatch && dentroDoPeriodo
    );
  });

  useEffect(() => {
    dispatch(getSaidaProduto());
  }, []);

  const handleBuscaChange = useCallback((e) => {
    setInputSeacrh(e.target.value);
  }, []);

  const handleExportExcel = () => {
    const data = agroupData ? Object.values(useGroupDataByID(dadosFiltrados)) : dadosFiltrados;
    useExportExcel(data, 'Registros de saidas');
  };

  return (
    <Main>
      <div className="sm:flex">
        <Title>Ultimas Saidas</Title>
        <InputSearch search={handleBuscaChange} placeholder="Produto | Winthor | Equipamento" />
      </div>
      <div className="hidden sm:flex items-center justify-end gap-2 p-2 shadow-darkShadow mb-4 rounded-sm md:flex-wrap">
        <Typography variant="h5" color="white" className="font-bold md:hidden lg:flex">
          Filtros :
        </Typography>
        <Tooltip content={!agroupData ? 'Agrupar por produto' : 'Desagrupar'}>
          <IconButton
            variant="outlined"
            onClick={changeAgroupData}
            color="white"
            className={`${agroupData && 'bg-yellow-800 text-red-400 border-red-500'}`}
          >
            {agroupData ? <Merge /> : <Combine />}
          </IconButton>
        </Tooltip>
        <IconButton variant="outlined" onClick={handleExportExcel} color="white">
          <Download />
        </IconButton>
        <Input
          type="date"
          containerProps={{ className: 'max-w-[10rem]' }}
          color="white"
          label="Data inicial"
          {...register('dateInicial', { required: true })}
          error={!!errors?.dateInicial}
        />
        <Input
          type="date"
          label="Data final"
          color="white"
          containerProps={{ className: 'max-w-[10rem]' }}
          {...register('dateFinal', { required: true })}
          error={!!errors?.dateFinal}
        />
        <div className="w-52">
          <Select
            label="Linha"
            value={filtroLinha}
            onChange={(val) => setFiltroLinha(val)}
            className="text-white "
            labelProps={{
              className: 'text-white peer-focus:text-white',
            }}
            containerProps={{
              className: 'relative border-white',
            }}
            color="white"
          >
            {LOCAIS_SAIDA.map((item) => (
              <Option value={item.nome}>{item.nome}</Option>
            ))}
          </Select>
        </div>

        <Button variant="filled" color="amber" onClick={handleSubmit(onFiltro)}>
          Aplicar Filtro
        </Button>
        <Button variant="filled" color="blue-gray" onClick={clearError}>
          Limpar
        </Button>
      </div>
      <div className="h-[92%] shadow-darkShadow ">
        {!agroupData && (
          <TableHistoricSaida columns={columns} rows={dadosFiltrados} loading={loading} />
        )}
        {agroupData && (
          <TableHistoricSaidaAgroup
            columns={columnsAgroup}
            rows={useGroupDataByID(dadosFiltrados)}
            loading={loading}
          />
        )}
      </div>
    </Main>
  );
};

export default HistoricoSaida;

const limparParametroHistorico = (searchParams, setSearchParams) => {
  // Cria uma cópia dos parâmetros atuais
  const newParams = new URLSearchParams(searchParams.toString());

  // Remove o parâmetro desejado
  newParams.delete('historico');

  // Atualiza a URL sem o parâmetro
  setSearchParams(newParams);
};
